import { Typography } from "@mui/material";
import { format, millisecondsInSecond } from "date-fns";
import { useLayoutEffect, useState } from "react";
import DialogWithCloseButton from "@/components/common/modals/dialogWithCloseButton";
import { WorkShiftDialogType } from "@/components/serviceFlow/clockin/workShiftDialog/workShiftDialog";
import { TEXT_PRIMARY_DARK, TEXT_SECONDARY } from "@/config/mui/colorPalette";
import theme from "@/config/mui/theme";
import { useMedspaId } from "@/hooks/common/useMedspaId";
import useMedspaTimezone from "@/hooks/common/useMedspaTimezone";

export type StartWorkShiftDialogProps = {
  type: WorkShiftDialogType.START;
  isOpen: boolean;
  handleStartShift: () => void;
  handleCancel: () => void;
};

export default function StartWorkShiftDialog({
  isOpen,
  handleStartShift,
  handleCancel,
}: StartWorkShiftDialogProps) {
  const medspaId = useMedspaId();
  const { utcToMedspaZonedTime } = useMedspaTimezone(medspaId);

  const [currentDate, setCurrentDate] = useState<Date | undefined>(undefined);

  useLayoutEffect(() => {
    setCurrentDate(utcToMedspaZonedTime(new Date().toISOString()));
    const updateShiftDurationInterval = setInterval(
      () => setCurrentDate(utcToMedspaZonedTime(new Date().toISOString())),
      millisecondsInSecond
    );

    return () => clearInterval(updateShiftDurationInterval);
  }, [utcToMedspaZonedTime]);

  if (!currentDate) return;

  return (
    <DialogWithCloseButton
      isOpen={isOpen}
      title="Start your workshift"
      content={
        <Typography color={TEXT_SECONDARY}>
          Start time for your shift will be recorded as{" "}
          <span
            style={{
              ...theme.typography.subtitleDefault,
              color: TEXT_PRIMARY_DARK,
            }}
          >
            {format(currentDate, "p")} on {format(currentDate, "PPP")}
          </span>
        </Typography>
      }
      primaryButtonText="Start shift"
      handlePrimaryClick={handleStartShift}
      handleCancel={handleCancel}
    />
  );
}
